/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react'; // we need this to make JSX compile
import { Logger } from '../../../../../libs/utils/logger';
import { Grid } from '@mui/material';
import { HeaderSignup } from '../../HeaderSignup';
import { CustomerType } from '../../../../../types/common.interfaces';
import { JointTenancyCoOwnerSignUp } from './JointTenancyCoOwnerSignUp';

/**
 * Author : Shivaraj PP
 * Component: JointTenancyCoOwnerSignUpWrapper
 * Description: Wrapper for Joint Tenancy Co-Owner Sign Up
 */

Logger.debug("JointTenancyCoOwnerSignUpWrapper.tsx", "Sign up joint tenancy initializing")

export const JointTenancyCoOwnerSignUpWrapper: React.FC<any> = React.memo(() => {
  const source = {
    url: "/",
    method: "GET",
    data: {}
  }
  return (
    <Grid item container xs={12}>
      <HeaderSignup percentage={60} logoutIconRequired={true} customerType={CustomerType.JOINT_TENANCY} />
      <div style={{ display: 'flex', flex: 1 }}>
        <JointTenancyCoOwnerSignUp source={source} id={"joint-tenancy-user-signup"} />
      </div>
    </Grid>
  );
});
